import React, { useMemo, useRef } from 'react'
import ReactEcharts from "echarts-for-react";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const CompletionAnalysis = ({ currentSurvey, survey_id }) => {

    //States
    const { completionData } = useSelector((state) => state.analyticsData)
    const { t, i18n } = useTranslation();
    //Options (Memo)
    const completionSurveys = useMemo(() => {
        return {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {},
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: {
                type: 'value'
            },
            yAxis: {
                type: 'category',
                data: [''],
                name: currentSurvey?.name ?? '',
                nameLocation: 'middle',
                nameGap: 10,
            },
            series: [
                {
                    name: t('analytics.inComplete'),
                    barWidth: '40px',
                    type: 'bar',
                    stack: 'total',
                    emphasis: {
                        focus: 'series'
                    },
                    data: [completionData?.incomplete ?? 0],
                    itemStyle: {
                        color: '#FECB00'
                    },
                },
                {
                    name: t('analytics.complete'),
                    type: 'bar',
                    stack: 'total',
                    barWidth: '40px',
                    emphasis: {
                        focus: 'series'
                    },
                    data: [completionData?.complete ?? 0],
                    itemStyle: {
                        color: '#E60000'
                    },
                },
            ],
            // graphic: (completionData?.complete || completionData?.incomplete) ? null : [{
            //     type: 'text',
            //     top: 'middle',
            //     left: 'center',
            //     style: {
            //         text: 'No Data',
            //         fontSize: 40
            //     }
            // }],
        }
    }, [completionData?.complete, completionData?.incomplete, currentSurvey?.name])


    return (
        <>
            <div className="card dashboard-card min-100">
                <div className="dashboard-card-header mb-4">
                    <h3>{t('analytics.completion_analysis')}
                    </h3>
                </div>
                <div className="card-body">
                    <div className="chart-text">
                        <ul className='text-data'>
                            {/* <li>{`Total survey responses: ${completionData?.total ?? 0}`}</li> */}
                            {/* <li>{`Completed surveys: ${completionData?.complete ?? 0}`}</li> */}
                            <li>{`${t('analytics.totals.total_survey_responses')}: ${completionData?.total ?? 0}`}</li>
                            <li>{`${t('analytics.totals.completed_surveys')}: ${completionData?.complete ?? 0}`}</li>

                        </ul>
                    </div>
                    <div className="chart-wrapper">
                        <ReactEcharts
                            option={completionSurveys} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default CompletionAnalysis